__turbopack_context__.v({
  "buttonTrigger": "rNCfZa_buttonTrigger",
  "iconTrigger": "rNCfZa_iconTrigger",
  "inline": "rNCfZa_inline",
  "item": "rNCfZa_item",
  "itemCopied": "rNCfZa_itemCopied",
  "popup": "rNCfZa_popup",
  "popupTitle": "rNCfZa_popupTitle",
  "positioner": "rNCfZa_positioner",
});
